import { Box, Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export function PageHeader({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <Box component="header" sx={{ mb: 3 }}>
      <Breadcrumbs sx={{ mb: 1, fontSize: 13 }}>
        <Link to="/dashboard">Home</Link>
        <Typography color="text.secondary" fontSize={13}>
          {title}
        </Typography>
      </Breadcrumbs>
      <Typography variant="h1">{title}</Typography>
      {description && (
        <Typography color="text.secondary" sx={{ mt: 0.75 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
